import { render, staticRenderFns } from "./CustomerStories_phone.vue?vue&type=template&id=57e82e5b&scoped=true&"
import script from "./CustomerStories_phone.vue?vue&type=script&lang=js&"
export * from "./CustomerStories_phone.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStories_phone.vue?vue&type=style&index=0&id=57e82e5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e82e5b",
  null
  
)

export default component.exports